import { Container, Title, Text, Paper, Stack, Box, Divider, Anchor, Group } from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import SEO from '../layout/SEO';
import { LEGAL_SECTIONS } from '../../data/legalContent';

/**
 * Legal component displays legal documents like Terms of Service or Privacy Policy.
 * It dynamically fetches content based on the provided sectionId.
 * @param {Object} props - Component properties.
 * @param {string} props.sectionId - The unique identifier for the legal document.
 */
export default function Legal({ sectionId }) {
    const doc = LEGAL_SECTIONS.find(s => s.id === sectionId);

    if (!doc) return <Box c="white" p={50} ta="center">Document Not Found</Box>;

    return (
        <Box bg="#050505" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <SEO
                title={doc.label}
                description={`Read our ${doc.label}. Last updated ${doc.lastUpdated}.`}
                path={`/${sectionId}`}
            />

            <Navbar />

            <Container size="md" py={{ base: 60, md: 100 }} style={{ flex: 1 }}>
                <Anchor component={Link} to="/" c="dimmed" size="sm" mb="xl" style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
                    <IconChevronLeft size={14} /> Back to Home
                </Anchor>

                <Stack gap="xl">
                    <Box>
                        <Group align="center" gap="sm" mb="xs">
                            <doc.icon size={32} color="#228be6" />
                            <Title order={1} size="3rem" fw={900} style={{ letterSpacing: '-1px' }}>
                                {doc.label}
                            </Title>
                        </Group>
                        <Text c="dimmed" size="lg">
                            Last Updated: <span style={{ color: 'white' }}>{doc.lastUpdated}</span>
                        </Text>
                    </Box>

                    <Divider color="rgba(255,255,255,0.1)" />

                    <Paper
                        p={{ base: 'lg', md: 'xl' }}
                        radius="lg"
                        bg="rgba(255, 255, 255, 0.03)"
                        withBorder
                        style={{ borderColor: 'rgba(255, 255, 255, 0.05)', lineHeight: 1.8 }}
                    >
                        {doc.content}
                    </Paper>
                </Stack>
            </Container>

            <Footer />
        </Box>
    );
}